<div class="container-tig-item">
    <div class="help-c-title">
        <h4>蒙古文无衬线报体与Noto sans Mongolian</h4>
    </div>
    <div>
        <p>Noto sans Mongolian字体是由蒙纳字库伦敦办公室日本字体设计师大曲都市（ Toshi Omagari） 参与设计的一款无衬线蒙古文字体，在安卓手机、各种界面设计中广泛使用该字体。那么Noto sans Mongolian字体和蒙古文无衬线报体有什么区别呢？我们先比较一下这两种字体的笔画。（左：Noto sans Mongolian体，右：蒙古文无衬线报体）</p>
        <br>
    </div>
    <div class="Vsbt-img-cont">
        <div class="Vsbt-img">
            <img src="/assets/images/VsNsm/1.jpg" alt="蒙古文无衬线报体 - 图片">
        </div>
        <div class="Vsbt-img">
            <img src="/assets/images/VsNsm/2.jpg" alt="蒙古文无衬线报体 - 图片">
        </div>
        <div class="Vsbt-img">
            <img src="/assets/images/VsNsm/3.jpg" alt="蒙古文无衬线报体 - 图片">
        </div>
        <div class="Vsbt-img">
            <img src="/assets/images/VsNsm/4.jpg" alt="蒙古文无衬线报体 - 图片">
        </div>
        <div class="Vsbt-img">
            <img src="/assets/images/VsNsm/5.jpg" alt="蒙古文无衬线报体 - 图片">
        </div>

        <div class="Vsbt-img">
            <img src="/assets/images/VsNsm/6.jpg" alt="蒙古文无衬线报体 - 图片">
        </div>

        <div class="Vsbt-img">
            <img src="/assets/images/VsNsm/7.jpg" alt="蒙古文无衬线报体 - 图片">
        </div>

        <div class="Vsbt-img">
            <img src="/assets/images/VsNsm/8.jpg" alt="蒙古文无衬线报体 - 图片">
        </div>

        <div class="Vsbt-img">
            <img src="/assets/images/VsNsm/9.jpg" alt="蒙古文无衬线报体 - 图片">
        </div>

    </div>
    <div>
        <p>通过比较能看出两种字体不同点是：1.笔画不同 2.字体粗细不同 3.字体《腰》长短不同。那么以 上不同点在字体使用中有什么影响呢？下面分别在小程序用户界面和网页导航栏做比较：</p>
        <br>
        <p>小程序用户界面中比较（左：蒙古文无衬线体，右：Noto sans Mongolian体）:</p>
    </div>
    <div class="Vsbt-img-cont">
        <div class="Vs-nsm-img-1">
            <img src="/assets/images/VsNsm/10.jpg" alt="蒙古文无衬线报体 - 图片">
            <div>图1</div>
        </div>
        <div class="Vs-nsm-img-1">
            <img src="/assets/images/VsNsm/11.jpg" alt="蒙古文无衬线报体 - 图片">
            <div>图2</div>
        </div>
    </div>
    <p>图1中两种字体的长度一样但是因为笔画的粗细不一样所以两种字体的清晰度也不一样。这里蒙古文无衬线体的清晰度比Noto sans Mongolian体清晰度高。</p>
    <br>
    <p>图2中虽然两种字体清晰度一样，但是Noto sans Mongolian字体长度和宽度比蒙古文无衬线体大， 所谓的占用面积大。那么它的缺点是因整体界面中字体占用面积大，界面变得杂乱，导致影响界面 美观、影响视觉效果。</p>
    <br>
    <p>网页导航栏中比较</p>
    <div class="Vsbt-img-cont">
        <div class="Vs-nsm-img-2">
            <img src="/assets/images/VsNsm/12.jpg" alt="蒙古文无衬线报体 - 图片">
            <div>蒙古文无衬线体</div>
        </div>
        <div class="Vs-nsm-img-2">
            <img src="/assets/images/VsNsm/13.jpg" alt="蒙古文无衬线报体 - 图片">
            <div>Noto sans Mongolian体</div>
        </div>
    </div>
    <p>两中字体通过在网页导航栏比较后能看出，蒙汉两种文字并用的情况下Noto sans Mongolian体和汉文字粗细对比太明显，则显得轻重比例很不和谐，所以易读性和美观上蒙古文无衬线体更有优势。</p>
    <br>
    <p>总结：通过比较两种字体得到的结论是蒙古文无衬线体在清晰度、界面整体美观、多种语言字体并用的情况下比Noto sans Mongolian体更有优势。</p>
    <br>
    <br>
</div>